
import a1residential from '../assets/a1residential.png'
import prontocasecase from "../assets/pronto.png"
import waa from "../assets/waa.png"
import crm from "../assets/crm.png"
import PathFinder from "../assets/geo-location.png"
import Profile_Photo from "../assets/Raju_Profile_photo.gif"
import heroBg from "../assets/webdev.svg";
import cloud from "../assets/cloudBg.png";
import cloudDark from "../assets/cloudDark.png";
import iKidz from "../assets/ikidz.png";
import relaxNow from "../assets/relax-now.png"
import  pisteyo from "../assets/pisteyo.jpeg"
import monday from "../assets/monday.jpeg"
import ga from "../assets/ga.jpg"
import lovelife from "../assets/lovelife.jpg"
import sportsjournal from "../assets/sportsjournal.jpeg"
import TrendingNow from "../assets/TrendingNow.jpg"
import talktoenergy from "../assets/talktoenergy.jpeg"
import highcourt from "../assets/highcourt.jpeg"
import reliefhub from "../assets/reliefhub.jpg";
import hcba from "../assets/hcba.jpeg"
import skin_care from "../assets/skin-care-app.jpeg"
import swing from "../assets/swing-user.png"
import swingAdmin from "../assets/swing-admin.png"
import GaAdmin from "../assets/ga-admin.jpeg"
import WhatKeyAdmin from "../assets/what-key-admin.jpeg"
import ikidzschool from "../assets/ikidzschool.png";
import ikidz_smart_app from "../assets/ikidz_smart_app.jpg";
import hcba_app from "../assets/hcba_app.jpg";
import hcbaadvocate from "../assets/hcbaadvocate.png";
import rewind from "../assets/rewind.jpg";

import {calculateAgeInYears} from '../utills/calculateAgeInYears'
import { dob } from './common'

const shortIntro = `मैं एक फ्रंट-एंड / फुल-स्टैक डेवलपर हूं। मैं वर्तमान में एनिक्स 
                इनवेंटिव प्राइवेट लिमिटेड में फुल-स्टैक डेवलपर के रूप में काम कर रहा हूं।`
const techStack = [
  {
    name: "जावास्क्रिप्ट",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  
  {
    name: "टाइपप्रति",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    source:"https://www.typescriptlang.org/docs/",
  },
  {
    name: "रिएक्ट जेएस",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    source:"https://legacy.reactjs.org/docs/getting-started.html",

  },
  {
    name: "एंगुलर जेएस",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
    source:"https://angular.dev/overview",

  },  
  {
    name: "अगला Js",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original-wordmark.svg",
    source:"https://nextjs.org/docs",
  },
  {
    name: "जड़त्व जेएस",
    link: "https://avatars.githubusercontent.com/u/47703742?s=100&v=4",
    source:"https://inertiajs.com/"
  },
  {
    name: "रिडक्स",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    source:"https://handsonreact.com/docs/redux-thunk"
  },
  {
    name: "बूटस्ट्रैप",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
    source:"https://getbootstrap.com/docs/4.1/getting-started/introduction/"
  },
  {
    name: "सास",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
    source:"https://sass-lang.com/documentation/"
  }, 
  {
    name: "टेलविंड सीएसएस",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
    source:"https://tailwindcss.com/docs/installation/framework-guides"
  },
  {
    name: "सामग्री यूआई",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5nXwOB0nj3JI6mxepmQT1QC7hucMd9Fx1ig&s",
    source:"https://mui.com/material-ui/"
  },
  {
    name: "नोडजेएस",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    source:"https://www.w3schools.com/nodejs/default.asp"
  },
  {
    name: "एक्सप्रेस जेएस",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
    source:"https://devdocs.io/express/"
  },
  {
    name: "नेस्टजेएस",
    link: "https://docs.nestjs.com/assets/logo-small-gradient.svg",
    source: "https://docs.nestjs.com/"
  },
  {
    name: "मोंगो डीबी",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    source:"https://www.mongodb.com/docs/atlas/getting-started/"
  },
  {
    name: "मायएसक्यूएल",
    link: "https://w7.pngwing.com/pngs/962/92/png-transparent-database-mysql-backup-linux-command-line-interface-database-symbol-blue-commandline-interface-electric-blue-thumbnail.png",
    source:"https://dev.mysql.com/doc/"
  },
  {
    name: "डाकिया",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    source:"https://learning.postman.com/docs/introduction/overview/"
  },
  {
    name: "तीव्र गति",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
    source:"https://dart.dev/language"
  },
  {
    name: "स्पंदन",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg",
    source:"https://docs.flutter.dev/get-started/learn-flutter"
  },
  {
    name: "रिएक्ट नेटिव",
    link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
    source:"https://reactnative.dev/docs/getting-started"
  },
  {
    name: "एचटीएमएल",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/HTML"
  },
  {
    name: "सीएसएस",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/CSS"
  },
  {
    name: "हेरोकू",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
    source:"https://devcenter.heroku.com/articles/getting-started-with-nodejs"
  },
  {
    name: "गिट",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    source:"https://git-scm.com/docs"
  },
  // {
  //   name: "C Language",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg",
  // },
  {
    name: "सी++",
    link: "https://w7.pngwing.com/pngs/579/803/png-transparent-the-c-programming-language-programmer-computer-programming-programming-blue-logo-computer-program-thumbnail.png",
    source:"https://www.w3schools.com/cpp/"
  },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  {
    name: "फायरबेस",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    source:"https://firebase.google.com/docs"
  },
];

const contactLinks = [
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/29159rajusingh/",
  },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/rajusingh99",
  },
  {
    name: "Leetcode",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-level-up-your-coding-skills-and-quickly-land-a-job-logo-color-tal-revivo.png",
    link: "https://leetcode.com/u/RajusinghofficialIND/",
  },
  {
    name: "Stack Overflow",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png",
    link: "https://stackoverflow.com/users/19923888/raju-kumar",
  },
  {
    name: "Instagram",
    url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    link: "https://www.instagram.com/mr_singh_raju_/",
  },
  {
    name: "Youtube",
    url: "https://img.icons8.com/?size=50&id=85162&format=png&color=000000",
    link: "",
    // link: "https://www.youtube.com/@Coverage_Blogs",
  },
  {
    name: "X",
    url: "https://img.icons8.com/?size=50&id=13963&format=png&color=000000",
    link: "https://x.com/RajuSingh_159",
  },
];

 const serviceData = [
  {
    name: "Front-End Development",
    desc: `वेब डिज़ाइन में वेबसाइट के निर्माण और रखरखाव में कई अलग-अलग कौशल और अनुशासन शामिल हैं। 
          मैंने वेब डिज़ाइन, यूजर इंटरफ़ेस डिज़ाइन, रिस्पॉन्सिव डेवलपमेंट, स्टैंडर्ड-कंप्लायंट कोड, यूजर एक्सपीरियंस 
          (UX) डिज़ाइन और SEO-फ्रेंडली डेवलपमेंट पर ध्यान केंद्रित किया। यह दृष्टिकोण एक सहज और आकर्षक 
          उपयोगकर्ता अनुभव प्रदान करके आपके ब्रांड को बढ़ाता है।`,
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  },
  {
    name: "Back End Development",
    desc: `बैक एंड डेवलपमेंट किसी भी मजबूत और स्केलेबल वेब एप्लिकेशन की रीढ़ है। मेरी विशेषज्ञता सर्वर-साइड लॉजिक,
     डेटाबेस प्रबंधन और API एकीकरण के निर्माण और रखरखाव में निहित है जो गतिशील और उच्च-प्रदर्शन वाली वेबसाइटों को 
     शक्ति प्रदान करते हैं। मैं सर्वर-साइड डेवलपमेंट, डेटाबेस प्रबंधन, API डेवलपमेंट और एकीकरण सुरक्षा और प्रमाणीकरण,
      स्केलेबिलिटी और प्रदर्शन अनुकूलन, रखरखाव और समर्थन पर ध्यान केंद्रित करता हूं।.
           `,
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
  },
  {
    name: "Mobile Application Development",
    desc: `हम एंड्रॉइड प्लेटफ़ॉर्म पर कस्टम मोबाइल डेवलपमेंट, क्रॉस-प्लेटफ़ॉर्म ऐप बनाना,
     उपयोगकर्ता अनुभव डिज़ाइन करना और चैटबॉट और वॉयस-नियंत्रित सुविधाओं जैसे अभिनव मोबाइल
     इंटरफ़ेस को एकीकृत करना, आधुनिक और इंटरैक्टिव अनुभव प्रदान करने सहित मोबाइल एप्लिकेशन 
     डेवलपमेंट सेवाओं की एक श्रृंखला प्रदान करते हैं। बहुमुखी ऐप बनाना जो एंड्रॉइड और आईओएस 
     दोनों प्लेटफ़ॉर्म पर सहजता से काम करते हैं, जिससे आपके दर्शकों तक व्यापक पहुँच सुनिश्चित होती है।`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
  },

];

const about = (
        <>
          मैं एक सॉफ्टवेयर डेवलपर हूँ, जिसके पास {<b>{calculateAgeInYears(dob)}  साल</b>} का अनुभव है और प्रोजेक्ट को 
          कॉन्सेप्ट से लेकर पूरा करने का एक मजबूत ट्रैक रिकॉर्ड है। मैं वायरफ्रेम और डिज़ाइन 
          कॉन्सेप्ट को उच्च-प्रदर्शन वाले सॉफ़्टवेयर एप्लिकेशन में बदलने में माहिर हूँ, जो स्वच्छ, 
          पुन: प्रयोज्य और कुशल कोड के माध्यम से एक सहज उपयोगकर्ता अनुभव सुनिश्चित 
          करता है। मेरा जुनून डिज़ाइन, तकनीक और नवाचार को सम्मिश्रित करने में है, जो प्रत्येक 
          प्रोजेक्ट को शुरुआती विचार से लेकर अंतिम रिलीज़ तक मार्गदर्शन करता है। मुझे फ्रंटएंड
           और बैकएंड दोनों का अच्छा ज्ञान है। वर्तमान में, मैं बैकएंड डेवलपमेंट पर ध्यान केंद्रित कर
         रहा हूँ, जो मेरे काम की तकनीकी नींव को आगे बढ़ा रहा है।
        </>
        )
        
const detailAbout = (
  <>
    मैं <strong>टंडसपुर, सीतामढ़ी, बिहार</strong> का रहने वाला हूँ। 
    मैं <strong>चंडीगढ़</strong> और <strong>मोहाली</strong> में अनुभव रखने वाला एक 
    <strong> जुनूनी सॉफ्टवेयर इंजीनियर</strong> हूँ।{" "}
    <span>
      बहुत से लोग मुझे <strong>"राजू सिंह बिहार"</strong> या 
      <strong> "भारतीय सॉफ्टवेयर इंजीनियर"</strong> के नाम से भी जानते हैं।
    </span>
  </>
);
        

const technologies_tools =(
      <>
          अत्याधुनिक प्रौद्योगिकियों और विश्वसनीय ओपन-सोर्स सॉफ्टवेयर के संयोजन का उपयोग करके 
            मैं <b>स्मार्टफोन, टैबलेट, लैपटॉप और डेस्कटॉप</b> के लिए उपयोगकर्ता-केंद्रित, प्रदर्शनकारी ऐप्स और वेबसाइट
            बनाता हूं।
      </>
) 


const projects = [
  // webs
  {
    src: a1residential,
    type:"web",
    link:"https://www.a1-builders.com/",
    name:"A1आवासीयबिल्डर्स",
    figma:"https://www.figma.com/design/r5BUGIFP1Kzw2tvAEI3iv1/Untitled?node-id=0-1&p=f",
    adminFigma:"https://www.figma.com/design/g5AY22eZS5zAaIIFSFlUpG/A1---Admin?node-id=0-1&p=f",
    isSecure:false,
    description:`आपके घर का आकार चाहे जो भी हो, इसे बनाए रखना एक संघर्ष हो सकता है। 
    जबकि आपके पास अपनी टू-डू सूची में सब कुछ पूरा करने के लिए समय या उपकरण नहीं हो सकते हैं,
   आपके पास एक स्थानीय बाउर एक्स® है जिसमें विशेषज्ञों की एक विश्वसनीय टीम है जो सही तरीके से 
   काम करने की गारंटी के साथ सहायक सेवाएं प्रदान करती है।`
  },
  {
    src: prontocasecase,
    link:"https://prontocasecash.com/",
    name:"प्रोन्टो केस कैश",
    figma:"https://www.figma.com/design/nWX94AvnPPq8B6w4Y1mQtl/Law-firm-Probationary-Period?node-id=0-1&p=f",
    isSecure:false,
    type:"web",
    description:`क्या आप किसी वाहन या संपत्ति दुर्घटना जैसे फिसलने और गिरने से घायल हुए हैं? 
    क्या आपका कोई मामला लंबित है लेकिन आपको अभी पैसे की ज़रूरत है? हम हर दिन आप जैसे 
    लोगों की मदद करते हैं जो अपने मुकदमे के निपटारे के लिए एक और साल इंतज़ार नहीं कर सकते।
    हमारी आवेदन प्रक्रिया में 3 मिनट से भी कम समय लगता है और अक्सर हम उसी दिन आपके लिए 
    जवाब दे सकते हैं। अगर आपको हमारी मदद की ज़रूरत है, तो कृपया नीचे अपना केस सबमिट करें 
    बटन पर क्लिक करें ताकि हम आपकी मदद कर सकें।`
  },
  {
    src: waa,
    link:"https://weareappointments.com/",
    name:"हम नियुक्तियां हैं",
    type:"web",
    figma:null,
    isSecure:false,
    description:`WeAreAppointments को एजेंटों द्वारा एजेंटों के लिए बनाया गया था, जो कि केवल
     आवश्यकता के कारण था। लीड्स, गैर-अनन्य अपॉइंटमेंट्स, वेबिनार रजिस्ट्रार इत्यादि खरीदकर नए 
     संभावित ग्राहकों से मिलने के लिए अथक प्रयासों के बाद, हमने उपभोक्ताओं के सामने आने का 
     सबसे अच्छा तरीका विकसित करने का फैसला किया... वर्चुअल और प्री-सेट अपॉइंटमेंट्स बनाकर।
     आपके कैलेंडर पर किसी ऐसे व्यक्ति के साथ विशेष अपॉइंटमेंट दिखाने से बेहतर क्या हो सकता है 
     जिसे सहायता की आवश्यकता है? विकास और साझा ज्ञान में अनगिनत घंटे लगे हैं, जिसने हमें 
     अपने सिस्टम को आपकी उंगलियों पर लाने में सक्षम बनाया है। आपको शुभकामनाएँ और निरंतर
     सफलता की कामना!`
  },
  {
    src: crm,
    link:"https://drive.google.com/drive/folders/1sHENXJl4yReoVktjcp1u3kxXDs2VuDIs?usp=sharing",
    name:"कर्मचारी प्रबंधन",
    type:"web",
    figma:null,
    isSecure:false,
    description:`कर्मचारी प्रबंधन कर्मचारियों को संगठन के समग्र मिशन और लक्ष्यों को प्राप्त करने के लिए अपना सर्वश्रेष्ठ 
    प्रदर्शन करने में मदद करने का कार्य है। इसमें नियुक्ति से लेकर बर्खास्तगी तक का पूरा कर्मचारी सफर
    शामिल है। जबकि कोई सार्वभौमिक सूत्र नहीं है, प्रभावी कर्मचारी प्रबंधन के लिए उनके कार्यकाल के दौरान 
    कर्मचारियों के साथ संबंध बनाने की आवश्यकता होती है। इसके लिए उनके पेशेवर लक्ष्यों के संबंध में 
    उनके काम की निगरानी और माप करना भी आवश्यक है। प्रभावी कर्मचारी प्रबंधन अक्सर व्यक्तिगत
    प्रबंधकों और उनकी रिपोर्ट के साथ प्रेरित करने, संवाद करने और विश्वास बनाने की उनकी क्षमता 
    पर निर्भर करता है। सर्वश्रेष्ठ प्रबंधक अपने कर्मचारियों के लिए कोच के रूप में कार्य करते हैं, 
    जो उनके द्वारा किए जा रहे बेहतरीन काम को पहचानते हैं और उन्हें बेहतर बनाने के लिए चुनौती 
    देते हैं। जबकि ऐसे कई कार्य और कर्तव्य हैं जो कर्मचारी प्रबंधन के अंतर्गत आते हैं, उनमें से
    लगभग सभी पाँच श्रेणियों में से एक में फिट हो सकते हैं।`
  },
  {
    src: TrendingNow,
    link:"",
    name:"अभी का रुझान",
    type:"web",
    figma:"https://www.figma.com/design/shmxWL5FKRO5GNOPPopBg6/PLAY",
    isSecure:false,
    description:`बेहतरीन गेमिंग अनुभव के लिए तैयार हो जाइए, जहाँ एक्शन, रोमांच और मनोरंजन 
    एक साथ मिलते हैं! चाहे आप कैजुअल प्लेयर हों या हार्डकोर ईस्पोर्ट्स फैन, हमने आपके लिए शानदार
     गेमप्ले, प्रो टिप्स, लेटेस्ट गेमिंग न्यूज़ और इंटेंस मल्टीप्लेयर बैटल की व्यवस्था की है। हमारे समुदाय में
    शामिल हों, अपने कौशल को बढ़ाएँ और गेमिंग की दुनिया में आगे रहें!... नॉन-स्टॉप गेमिंग कंटेंट के 
    लिए LIKE, SHARE और SUBSCRIBE करें! 🔔 अपडेट के लिए बने रहें! 
    🚀 #PLAY #GamingCommunity #GameOn #LevelUp
      `
  },
  {
    src: iKidz,
    link:"https://ikidzschools.com/",
    name:"भारत का पहला तकनीक-सक्षम प्रीस्कूल",
    type:"web",
    figma:null,
    isSecure:false,
    description:`भारत का पहला और एकमात्र प्रीस्कूल जिसने अपने खुद के इन-हाउस विकसित ऐप
      के साथ प्रीस्कूल में ऑगमेंटेड रियलिटी को शामिल किया है, IKidz सीखने को एक नया अर्थ देता 
      है। इसमें मजेदार लर्निंग मॉड्यूल शामिल हैं जो बच्चों को अक्षर, संख्या, आकृतियाँ, ऋतुओं की संख्या
      और बहुत कुछ सीखने में मदद करते हैं। यह सब एक नए तरीके से किया गया है जो भारत में कोई
      अन्य प्लेस्कूल नहीं कर सकता। सभी IKidz स्कूल ऑगमेंटेड रियलिटी सक्षम फ्लैश कार्ड और टैबलेट
      से लैस हैं।`
  },
  {
    src: relaxNow,
    link:"https://nwnt.ai/",
    name:"एनडब्ल्यूएनटी",
    type:"web",
    figma:null,
    isSecure:false,
    description:`एनडब्ल्यूएनटी तनाव और/या जीवनशैली संबंधी समस्याओं से उत्पन्न मानसिक, 
    भावनात्मक और व्यवहारिक स्वास्थ्य समस्याओं के लिए एक संपूर्ण समाधान है।`
  },
  {
    src: PathFinder,
    link:"https://path-finder-google-maps.netlify.app/",
    name:"गूगल मैप्स द्वारा पथ खोजक",
    type:"web",
    figma:null,
    isSecure:false,
    description:`यह आपके स्थान से गंतव्य तक का रास्ता ढूंढने में सक्षम है।`
  },
  {
    src: pisteyo,
    link:"https://teams.microsoft.com/v2/",
    name:"माइक्रोसॉफ्ट पिस्तेयो ऐप",
    type:"web",
    figma:null,
    isSecure:false,
    description:`पिस्टेयो एक एआई कंसल्टिंग फर्म है जो माइक्रोसॉफ्ट कोपायलट अपनाने में विशेषज्ञता
     रखती है, जो अनुकूलित प्रशिक्षण, वर्कफ़्लो ऑटोमेशन और कस्टम जीपीटी चैटबॉट प्रदान करती है।
     उनका माइक्रोसॉफ्ट टीम्स ऐप (बीटा में) कोपायलट के उपयोग के लिए सकारात्मक आदतों और 
     सर्वोत्तम प्रथाओं को बढ़ावा देता है, उत्पादकता बढ़ाता है और वर्कफ़्लो को सुव्यवस्थित करता है।`
  },
  {
    src: monday,
    link:"https://terdia.monday.com/boards",
    name:"Monday.com इंस्टॉल ऐप सुविधा",
    type:"web",
    figma:null,
    isSecure:false,
    description:`परियोजना की प्रगति को व्यवस्थित करने और ट्रैक करने के लिए मंडे.कॉम की बोर्ड
     सुविधा का लाभ उठाया गया, जिससे निर्बाध संचार और कार्य प्रबंधन की सुविधा मिली, जिसके 
     परिणामस्वरूप टीम सहयोग और परियोजना दक्षता में सुधार हुआ।`
  },
  {
    src: talktoenergy,
    link:"https://demo.talktomyenergy.ai",
    name:"ऊर्जा से बात करें",
    type:"web",
    figma:"https://www.figma.com/design/CB5fTEjZvptQ81oe2GiCfh/Mohit_works_21-Apr?node-id=48-2&p=f",
    isSecure:false,
    description:`टॉक टू माय एनर्जी - स्मार्ट एनर्जी इनसाइट्स और एआई चैटबॉट टॉक टू माय एनर्जी एक उन्नत
     प्लेटफ़ॉर्म है जो एक इंटरैक्टिव चैटबॉट के माध्यम से एआई-संचालित ऊर्जा अंतर्दृष्टि प्रदान करता है। 
     यह उपयोगकर्ताओं को मासिक ग्राफ़ और रिपोर्ट के साथ अपनी ऊर्जा खपत की निगरानी और विश्लेषण
    करने में मदद करता है, जिससे ऊर्जा प्रबंधन सरल और कुशल हो जाता है। चैटबॉट प्रश्नों का उत्तर
    देता है, वास्तविक समय का डेटा प्रदान करता है, और ऊर्जा उपयोग को अनुकूलित करने के लिए
    कार्रवाई योग्य अंतर्दृष्टि प्रदान करता है।`
  },
  {
    src: highcourt,
    link:"https://punjabharyanahighcourtbar.in",
    name:"पंजाब एवं हरियाणा हाईकोर्ट बार एसोसिएशन",
    type:"web",
    isSecure:false,
    figma:null,
    description:`पंजाब एवं हरियाणा उच्च न्यायालय बार एसोसिएशन पंजाब एवं हरियाणा उच्च 
    न्यायालय में वकालत करने वाले अधिवक्ताओं का प्रतिनिधित्व करने वाली एक प्रतिष्ठित कानूनी 
    संस्था है। न्याय, कानूनी नैतिकता और पेशेवर उत्कृष्टता को बनाए रखने के लिए प्रतिबद्ध, यह
   एसोसिएशन न्यायपालिका और कानूनी पेशेवरों के बीच एक महत्वपूर्ण कड़ी के रूप में कार्य 
   करता है। कानूनी उत्कृष्टता की समृद्ध विरासत के साथ, एसोसिएशन कानूनी जागरूकता और
   पेशेवर विकास को बढ़ावा देने के लिए सेमिनार, कार्यशालाएँ और कार्यक्रम आयोजित करता है।
   एक मजबूत कानूनी समुदाय को बढ़ावा देने के लिए समर्पित, यह क्षेत्र में न्याय के सुचारू 
   प्रशासन को सुनिश्चित करने में महत्वपूर्ण भूमिका निभाता है।`
  },
  {
    src: hcba,
    link:"https://hcba.anixinventive.com/",
    name:"हाई कोर्ट बार एसोसिएशन",
    type:"web",
    figma:null,
    isSecure:true,
    description:`पंजाब एवं हरियाणा उच्च न्यायालय बार एसोसिएशन पंजाब एवं हरियाणा उच्च 
    न्यायालय में वकालत करने वाले अधिवक्ताओं का प्रतिनिधित्व करने वाली एक प्रतिष्ठित कानूनी
   संस्था है। न्याय, कानूनी नैतिकता और पेशेवर उत्कृष्टता को बनाए रखने के लिए प्रतिबद्ध, यह
    एसोसिएशन न्यायपालिका और कानूनी पेशेवरों के बीच एक महत्वपूर्ण कड़ी के रूप में कार्य 
    करता है। कानूनी उत्कृष्टता की समृद्ध विरासत के साथ, एसोसिएशन कानूनी जागरूकता और
   पेशेवर विकास को बढ़ावा देने के लिए सेमिनार, कार्यशालाएँ और कार्यक्रम आयोजित करता है।
   एक मजबूत कानूनी समुदाय को बढ़ावा देने के लिए समर्पित, यह क्षेत्र में न्याय के सुचारू प्रशासन
   को सुनिश्चित करने में महत्वपूर्ण भूमिका निभाता है।`
  },
  {
    src: swing,
    link:"https://opaqueswingers.com/index",
    name:"सर्वश्रेष्ठ स्विंगर डेटिंग ऐप",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`रोमांच पसंद करने वाले जोड़ों और सिंगल्स के लिए डिज़ाइन किए गए सुरक्षित, 
    सम्मानजनक और खुले विचारों वाले स्थान पर कदम रखें। चाहे आप नए अनुभवों की खोज करना
   चाहते हों, समान विचारधारा वाले लोगों से जुड़ना चाहते हों या अपनी जीवनशैली के लिए सही मैच
   ढूँढना चाहते हों, हमारा ऐप इसे आसान बनाता है। सत्यापित उपयोगकर्ताओं के साथ वास्तविक 
   कनेक्शन खोजें, सुरक्षित रूप से चैट करें और स्थानीय ईवेंट या निजी समूहों में शामिल हों। स्मार्ट
   मैचिंग, विवेकपूर्ण सुविधाओं और निर्णय-मुक्त समुदाय के साथ, आपका अगला रोमांचक कनेक्शन 
   बस एक स्वाइप दूर है।`
  },
  {
    src: swingAdmin,
    link:"https://admin.opaqueswingers.com/admin-login",
    name:"अल्टीमेट स्विंगर डेटिंग ऐप एडमिन",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`रोमांच पसंद करने वाले जोड़ों और सिंगल्स के लिए डिज़ाइन किए गए सुरक्षित, 
    सम्मानजनक और खुले विचारों वाले स्थान पर कदम रखें। चाहे आप नए अनुभवों की खोज करना
   चाहते हों, समान विचारधारा वाले लोगों से जुड़ना चाहते हों या अपनी जीवनशैली के लिए सही मैच
   ढूँढना चाहते हों, हमारा ऐप इसे आसान बनाता है। सत्यापित उपयोगकर्ताओं के साथ वास्तविक 
   कनेक्शन खोजें, सुरक्षित रूप से चैट करें और स्थानीय ईवेंट या निजी समूहों में शामिल हों। स्मार्ट
   मैचिंग, विवेकपूर्ण सुविधाओं और निर्णय-मुक्त समुदाय के साथ, आपका अगला रोमांचक कनेक्शन 
   बस एक स्वाइप दूर है।`
  },
  {
    src: GaAdmin,
    link:"https://ga-staging.castledigital.com.au/",
    name:"दुःख ऑस्ट्रेलिया एडमिन",
    type:"web",
    figma:null,
    isSecure:true,
    description:`ग्रिफ़ ऑस्ट्रेलिया एडमिन पैनल एक व्यापक बैकएंड प्रबंधन प्रणाली है जिसे ग्रिफ़ 
    ऑस्ट्रेलिया के संचालन का समर्थन करने के लिए विकसित किया गया है, जो शोक और शोक
     सहायता सेवाएँ प्रदान करने वाला एक अग्रणी संगठन है। यह प्लेटफ़ॉर्म प्रशासकों को एक सुरक्षित,
     उपयोगकर्ता-अनुकूल इंटरफ़ेस के माध्यम से उपयोगकर्ताओं, संसाधनों, कार्यक्रमों, घटनाओं और
     सामग्री को कुशलतापूर्वक प्रबंधित करने में सक्षम बनाता है। स्केलेबिलिटी और उपयोग में आसानी
     को ध्यान में रखते हुए डिज़ाइन किया गया, एडमिन पैनल संगठन के लिए सुचारू दैनिक संचालन
     सुनिश्चित करने के लिए सामग्री अपडेट, उपयोगकर्ता अनुमतियाँ, डेटा ट्रैकिंग और सिस्टम
     कॉन्फ़िगरेशन को सुव्यवस्थित करता है।`
  },
  {
    src: WhatKeyAdmin,
    link:"https://app.whatkey.io/",
    name:"क्या कुंजी",
    type:"web",
    figma:null,
    isSecure:true,
    description:`WhatKey एडमिन पैनल WhatKey कुंजी प्रबंधन प्लेटफ़ॉर्म के संचालन के प्रबंधन के
     लिए एक केंद्रीकृत बैकएंड सिस्टम है। प्रशासकों के लिए डिज़ाइन किया गया, यह पैनल डिजिटल
     कुंजी असाइनमेंट, उपयोगकर्ता पहुँच स्तर, ऑडिट ट्रेल्स और संपत्ति ट्रैकिंग पर सहज नियंत्रण की
     अनुमति देता है। एक साफ यूआई और मजबूत कार्यक्षमता के साथ, यह उपयोगकर्ताओं की देखरेख,
     भौतिक और डिजिटल कुंजियों का प्रबंधन और उपयोग इतिहास की निगरानी की प्रक्रिया को सरल
     बनाता है - संगठनों के लिए सुरक्षित और कुशल कुंजी वितरण सुनिश्चित करता है।`
  },
  {
    src: ikidzschool,
    link: "https://app.ikidzschools.com/",
    name: "इकिड्ज़ स्कूल",
    type: "web",
    figma: null,
    isSecure: true,
    description: `IkidzSchool एडमिन पैनल एक शक्तिशाली और 
    उपयोगकर्ता-अनुकूल बैकएंड प्रबंधन प्रणाली है जिसे विशेष रूप से 
    प्रीस्कूल और डेकेयर केंद्रों के लिए डिज़ाइन किया गया है। यह स्कूल
   प्रशासकों और शिक्षकों को एक केंद्रीकृत प्लेटफ़ॉर्म प्रदान करता है जिससे
   वे कई केंद्रों में दैनिक कार्यों को आसानी और सटीकता से प्रबंधित कर
   सकते हैं। सटीक उपस्थिति रिकॉर्ड बनाए रखने, कक्षाओं का समय 
   निर्धारित करने और पौष्टिक भोजन मेनू की योजना बनाने से लेकर
   अभिभावकों के साथ रीयल-टाइम संचार और बच्चों की सुरक्षा के 
   लिए लाइव सीसीटीवी निगरानी तक - सब कुछ एक सहज डैशबोर्ड 
   में सहजता से एकीकृत है। यह पैनल शहर, राज्य, कर्मचारियों के 
   विवरण और प्रभारी भूमिकाओं जैसे आवश्यक डेटा तक त्वरित पहुँच 
   प्रदान करके कुशल केंद्र-वार प्रबंधन की अनुमति देता है। यह सदस्यता
    ट्रैकिंग और व्यावसायिक अंतर्दृष्टि का भी समर्थन करता है, 
    जिससे प्रशासकों को प्रत्येक केंद्र के प्रदर्शन और संचालन की स्पष्ट 
    जानकारी मिलती है। पैमाने पर निर्मित, IkidzSchool एडमिन पैनल 
    डेटा सुरक्षा, अभिगम नियंत्रण और परिचालन पारदर्शिता सुनिश्चित करता है
   - जिससे शिक्षक प्रारंभिक बाल विकास पर अधिक ध्यान केंद्रित कर सकते 
   हैं जबकि बाकी सब तकनीक संभालती है। अपने स्पष्ट डिज़ाइन और मजबूत
    विशेषताओं के साथ, यह स्कूल प्रशासन को सरल बनाता है और कर्मचारियों 
    और अभिभावकों दोनों के साथ जुड़ाव को बढ़ाता है, जिससे यह आधुनिक 
    प्रीस्कूल प्रबंधन के लिए एक अनिवार्य उपकरण बन जाता है।`,
  },
  {
    src: hcbaadvocate,
    link: "https://hcbasp.anixinventive.com/",
    name: "कानूनी पेशेवरों (वकील) को सशक्त बनाना",
    type: "web",
    figma: null,
    isSecure: true,
    description: `पंजाब एवं हरियाणा उच्च न्यायालय बार एसोसिएशन, पंजाब एवं हरियाणा 
    उच्च न्यायालय में कार्यरत अधिवक्ताओं का प्रतिनिधित्व करने वाली एक प्रतिष्ठित विधिक 
    संस्था है। न्याय, निष्ठा और विधिक उत्कृष्टता के प्रति अपनी दृढ़ प्रतिबद्धता के साथ,
   यह एसोसिएशन विधिक बिरादरी और न्यायपालिका के बीच एक सेतु का काम करती है,
   जिससे पूरे क्षेत्र में न्याय का प्रभावी प्रशासन सुनिश्चित होता है। पारदर्शिता, दक्षता और 
   सदस्यों की सुविधा बढ़ाने के लिए, हमें एडवोकेट डिजिटल पैनल की शुरुआत करते हुए
    गर्व हो रहा है, जो विधि पेशेवरों की आधुनिक आवश्यकताओं को पूरा करने के लिए 
    तैयार किया गया एक व्यापक वेब-आधारित प्लेटफ़ॉर्म है।`,
  },
  {
    src: reliefhub,
    link: "https://www.reliefhub.app/login",
    name: "ReliefHub.",
    type: "web",
    figma: "https://www.figma.com/design/XBYc0SkH3YI41rGIRZjd0d/AR-Copy?node-id=334-17637&p=f",
    isSecure: true,
    description: `ReliefHub एक व्यापक आपदा राहत प्रबंधन प्रणाली है, जिसे संगठनों, स्वयंसेवकों और प्रभावित गृहस्वामियों के बीच समन्वय को सरल और प्रभावी बनाने के लिए डिज़ाइन किया गया है।
    यह एक केंद्रीकृत प्लेटफ़ॉर्म प्रदान करता है जो राहत कार्यों को कुशलतापूर्वक प्रबंधित करने में मदद करता है — कार्य आदेशों को ट्रैक करने से लेकर टीमों के साथ संचार करने और वास्तविक समय की रिपोर्ट तैयार करने तक।
    इस सिस्टम में छह अलग-अलग प्रकार के लॉगिन हैं, जो प्रत्येक उपयोगकर्ता की भूमिका और अनुमति के अनुसार बनाए गए हैं, ताकि जानकारी सुरक्षित रहे और हर उपयोगकर्ता को उसकी भूमिका के अनुसार उचित पहुंच और कार्यक्षमता मिल सके।`,
  },
  // apps
  {
    src: ga,
    link:"",
    name:"दुःख ऑस्ट्रेलिया",
    type:"apps",
    figma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1729-6926&p=f",
    adminFigma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1047-6597&p=f",
    description:`ग्रिफ़ ऑस्ट्रेलिया एक ऐसा संगठन है जो दुःख और क्षति का सामना कर रहे व्यक्तियों 
    और परिवारों को सहायता, शिक्षा और संसाधन प्रदान करता है। वे लोगों को शोक से उबरने में मदद
   करने के लिए परामर्श सेवाएँ, प्रशिक्षण कार्यक्रम और शोध पहल प्रदान करते हैं। संगठन किसी प्रियजन
   की मृत्यु से निपटने में मदद करने के लिए दयालु देखभाल, साक्ष्य-आधारित दृष्टिकोण और सामुदायिक
    सहायता पर ध्यान केंद्रित करता है।`
  },
  {
    src: lovelife,
    link:"https://play.google.com/store/apps/details?id=com.sa.lovelife&pli=1",
    name:"प्रेममय जीवन",
    type:"apps",
    figma:"https://drive.google.com/drive/folders/1Ag8DUABP0OKnpaoQEUTtO9o6dwmDV-BK",
    description:`"लव लाइफ" एक रोमांटिक कॉमेडी-ड्रामा एंथोलॉजी सीरीज़ है जिसका प्रीमियर एचबीओ मैक्स 
    पर हुआ था। यह अलग-अलग किरदारों की यात्रा का अनुसरण करता है क्योंकि वे समय के साथ प्यार,
   रिश्तों और व्यक्तिगत विकास को आगे बढ़ाते हैं। प्रत्येक सीज़न एक नए नायक पर केंद्रित होता है,
    जो पहले प्यार से लेकर स्थायी संबंधों तक रोमांस के साथ अपने अनुभवों की खोज करता है। यह
     शो हास्य और भावनात्मक गहराई के साथ आधुनिक रिश्तों के उतार-चढ़ाव को उजागर करता है।`
  },
  {
    src: sportsjournal,
    link:"",
    name:"खेल पत्रिका",
    type:"apps",
    figma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=283-463&p=f",
    adminFigma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=0-1&p=f",
    description:`स्पोर्ट्स जर्नल एक संरचित रिकॉर्ड है जो विभिन्न खेल आयोजनों पर उत्साह, विश्लेषण
     और व्यक्तिगत प्रतिबिंबों को कैप्चर करता है। यह एथलीटों, प्रशंसकों और विश्लेषकों के लिए खेल 
     की हाइलाइट्स, खिलाड़ी के प्रदर्शन, रणनीतियों और खेल जगत में रुझानों को दर्ज करने के लिए
      एक मंच के रूप में कार्य करता है।`
  },
  {
    src: skin_care,
    link:"",
    name:"त्वचा की देखभाल",
    type:"apps",
    figma:"https://www.figma.com/design/YOllk4yxV6hCJsLqBSA306/UpSkin-Project--Engineer-Preview-?node-id=13-742&p=f",
    description:`ऑल-इन-वन ऐप आपको बिना किसी परेशानी के स्वस्थ, चमकदार त्वचा पाने में 
    मदद करने के लिए डिज़ाइन किया गया है। होम स्क्रीन पर अपनी ज़रूरतों के हिसाब से बनाए गए
   स्किनकेयर उत्पादों की एक क्यूरेटेड सूची देखें, जिसमें सामग्री, समीक्षाएँ और विशेषज्ञ की सिफ़ारिशें
   शामिल हैं। व्यक्तिगत सलाह, नियमित सुझाव और अपनी स्किनकेयर संबंधी सवालों के तुरंत जवाब
   पाने के लिए हमारे बुद्धिमान AI-संचालित स्किन हेल्पर से चैट करें। खरीदारी करने से पहले विस्तृत
   उत्पाद जानकारी, सुरक्षा रेटिंग और उपयोगकर्ता समीक्षाएँ जल्दी से जानने के लिए बारकोड स्कैनर
   का उपयोग करें। अंत में, हमारे समुदाय स्थान में समान विचारधारा वाले व्यक्तियों से जुड़ें, जहाँ 
   आप अनुभव साझा कर सकते हैं, सुझाव प्राप्त कर सकते हैं और अपनी स्किनकेयर यात्रा पर 
   प्रेरित रह सकते हैं।`
  },
  {
    src: ikidz_smart_app,
    link: "https://play.google.com/store/apps/details?id=com.chouhan07.ikidz&pcampaignid=web_share",
    name: "इकिड्ज़ स्मार्ट",
    type: "apps",
    figma:null,
    description: `IkidzSchool पैरेंट ऐप एक समर्पित प्लेटफ़ॉर्म है जिसे अभिभावकों को 
    अपने बच्चे की प्रीस्कूल यात्रा से सक्रिय रूप से जोड़े रखने के लिए डिज़ाइन किया गया है। 
    सुरक्षित लॉगिन एक्सेस के साथ, अभिभावक अपने बच्चे की दैनिक उपस्थिति के बारे में 
    जानकारी प्राप्त करने के लिए आसानी से रीयल-टाइम उपस्थिति रिकॉर्ड देख सकते हैं।
     ऐप में एकीकृत लाइव सीसीटीवी स्ट्रीमिंग भी है, जिससे अभिभावक कक्षा और गतिविधि
     के समय अपने नन्हे-मुन्नों पर नज़र रख सकते हैं - जिससे मन की शांति और पारदर्शिता 
     सुनिश्चित होती है। घर और स्कूल के बीच संवाद की खाई को पाटकर, यह ऐप विश्वास 
     और भागीदारी को बढ़ावा देता है, जिससे अभिभावकों को अपने बच्चे के शुरुआती सीखने
     के अनुभव में अग्रिम पंक्ति में बैठने का मौका मिलता है। सरल, सुरक्षित और विश्वसनीय 
     - IkidzSchool पैरेंट ऐप आधुनिक, सूचित पालन-पोषण के लिए एक आवश्यक 
     उपकरण है।`,
  },
  {
    src: hcba_app,
    link: "https://play.google.com/store/apps/details?id=com.advocate.hcba",
    name: "एचसीबीए-सीएचडी",
    type: "apps",
    figma:null,
    description: `पंजाब एवं हरियाणा उच्च न्यायालय बीएएस एसोसिएशन चंडीगढ़ मोबाइल
     ऐप अपने पंजीकृत उपयोगकर्ताओं को अपनी प्रोफ़ाइल ऑनलाइन एक्सेस और प्रबंधित 
     करने में सक्षम बनाता है। पंजाब एवं हरियाणा उच्च न्यायालय बीएएस एसोसिएशन 
     चंडीगढ़ मोबाइल ऐप अपने पंजीकृत उपयोगकर्ताओं को अपनी प्रोफ़ाइल ऑनलाइन 
     एक्सेस और प्रबंधित करने में सक्षम बनाता है। यह उपयोगकर्ताओं को अपने साथी 
     वकीलों को खोजने, भुगतान इतिहास देखने और कानूनी वेबसाइटों का तुरंत संदर्भ 
     लेने की सुविधा देता है। `,
  },
  {
    src: rewind,
    link: "https://play.google.com/store/apps/details?id=com.ianix.rewind",
    name: "Rewind",
    type: "apps",
    figma:null,
    description: `अंतरात्मा एक AI-संचालित आत्मचिंतन और माइंडफुलनेस ऐप है,
    जिसे उपयोगकर्ताओं को अपनी भीतरी आत्मा से जुड़ने में मदद करने के लिए बनाया गया है।
    यह ऐप आवाज़ और टेक्स्ट इंटरैक्शन के माध्यम से काम करता है।यह Gemini AI के जरिए 
    नेचुरल लैंग्वेज प्रोसेसिंग और भावनात्मक समझ की शक्ति को मिलाकर एक शांत, व्यक्तिगत और 
    आत्मीय अनुभव प्रदान करता है।
    उपयोगकर्ता ऐप में मौजूद स्पीच रिकग्निशन फीचर का उपयोग करके अपनी भावनाएँ व्यक्त कर सकते हैं।
    AI (अंतरात्मा) ध्यानपूर्वक सुनता है, समझता है, और संवेदनशीलता के साथ जवाब देता है —
    जिससे एक सुरक्षित डिजिटल स्थान बनता है जहाँ व्यक्ति अपने मन की बात खुलकर कह सकता है
    और आत्म-जागरूकता विकसित कर सकता है।`,
  },
]

const education =(
  <>
    <b>चंडीगढ़ इंजीनियरिंग कॉलेज से सूचना प्रौद्योगिकी में बी.टेक</b> की डिग्री प्राप्त करने के बाद ,
     मेरे पास सॉफ्टवेयर विकास और इंजीनियरिंग सिद्धांतों में एक मजबूत आधार है,
     साथ ही पूर्ण-स्टैक वेब विकास और अत्याधुनिक प्रौद्योगिकियों में व्यावहारिक अनुभव भी है।
  </>
)

// Top / sidebar Link
const links = [
  {
    name: "Home",
    route: "/",
  },
  {
    name: "About",
    route: "about",
  },
  {
    name: "Services",
    route: "services",
  },
  {
    name: "Projects",
    route: "projects",
  },
  {
    name: "Contact",
    route: "contact",
  },
];


const Constant = {
  about,detailAbout,
  technologies_tools,projects
  ,education,Profile_Photo,
  heroBg,cloud,cloudDark,
  shortIntro,techStack,
  contactLinks,links,serviceData
};
export default Constant;
